/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { TransactionCodeGroupModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class TransactionCodeGroupsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags TransactionCodeGroups
   * @name TransactionCodeGroupsGet
   * @summary Retrieves all the Transaction code groups.
   * @request GET:/transactionCodeGroups
   */
  transactionCodeGroupsGet = (params: RequestParams = {}) =>
    this.http.request<TransactionCodeGroupModelDto[], any>({
      path: `/transactionCodeGroups`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TransactionCodeGroups
   * @name TransactionCodeGroupsPost
   * @summary Add a new Transaction code group.
   * @request POST:/transactionCodeGroups
   */
  transactionCodeGroupsPost = (
    data: TransactionCodeGroupModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<TransactionCodeGroupModelDto, any[]>({
      path: `/transactionCodeGroups`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TransactionCodeGroups
   * @name TransactionCodeGroupsPut
   * @summary Updates the passed transaction code group.
   * @request PUT:/transactionCodeGroups/{id}
   */
  transactionCodeGroupsPut = (
    id: number,
    data: TransactionCodeGroupModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<TransactionCodeGroupModelDto, any[]>({
      path: `/transactionCodeGroups/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TransactionCodeGroups
   * @name TransactionCodeGroupsDelete
   * @summary Deletes the transaction group for the specified Id.
   * @request DELETE:/transactionCodeGroups/{id}
   */
  transactionCodeGroupsDelete = (id: number, params: RequestParams = {}) =>
    this.http.request<boolean, any>({
      path: `/transactionCodeGroups/${id}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
}
